
import { generateDaysofTheWeekOptions } from '../timeHelpers'

export const weekOptions = (() => {
  const [sunday, ...otherDays] = generateDaysofTheWeekOptions('dddd').map((week, index) => ({
    ...week, dayOfWeek: index,
  }))
  return [...otherDays, sunday]
})()

export const workingTimesHasShortMember = (workingTimes: [number, number][]) => {
  const threshold = 60

  const shortMembers = workingTimes.filter(timeframe => {
    const isShort = timeframe[1] - timeframe[0] < threshold
    return isShort
  })

  return shortMembers.length > 0
}